import React from 'react';
import PrimaryButtonLink from '../components/PrimaryButtonLink';
import PageSection from '../components/PageSection';
import ServiceCard from '../components/ServiceCard';
import InfoList from '../components/InfoList';

const services = [
  {
    title: 'Sviluppo Web',
    description:
      'Design system, performance e sicurezza per piattaforme B2B e B2C che crescono con il business.',
    icon: '🌐'
  },
  {
    title: 'Mobile Apps',
    description:
      'React Native e Flutter per app che uniscono UX premium e time-to-market rapido.',
    icon: '📱'
  },
  {
    title: 'System Integration',
    description:
      'API-first e automazioni che collegano ERP, CRM e servizi esterni senza attriti.',
    icon: '🔗'
  }
];

const Home = () => {
  return (
    <>
      <section className="hero">
        <div className="container hero-inner">
          <p className="eyebrow">Dal 1998</p>
          <h1>HelpSoftware – Soluzioni software dal 1998.</h1>
          <p className="hero-subtitle">
            Sviluppo software, consulenza IT, integrazioni avanzate per aziende
            che vogliono crescere in modo sicuro e sostenibile.
          </p>
          <div className="hero-actions">
            <PrimaryButtonLink to="/chi-siamo">Chi siamo</PrimaryButtonLink>
            <PrimaryButtonLink to="/contatti" variant="ghost">
              Contatti
            </PrimaryButtonLink>
          </div>
        </div>
      </section>

      <PageSection
        title="Servizi principali"
        intro="Sediamo al fianco di ogni cliente, costruiamo empatia e applichiamo un metodo unico per lavorare insieme, dall’idea al go-live."
      >
        <div className="service-grid">
          {services.map(service => (
            <ServiceCard key={service.title} {...service} />
          ))}
        </div>
      </PageSection>

      <PageSection
        title="Il nostro metodo"
        intro="Combiniamo empatia, strategia e delivery continuo per costruire partnership durature."
      >
        <div className="info-grid">
          <InfoList
            title="1. Scoperta"
            items={[
              'Workshop di co-design e analisi obiettivi',
              'Mappatura stakeholder e flussi operativi'
            ]}
          />
          <InfoList
            title="2. Costruzione"
            items={[
              'Design system condiviso e sprint agili',
              'Testing continuo e demo bisettimanali'
            ]}
          />
          <InfoList
            title="3. Crescita"
            items={[
              'Osservabilità e KPI di prodotto',
              'Release plan e supporto dedicato'
            ]}
          />
        </div>
      </PageSection>
    </>
  );
};

export default Home;
